import { Loader as LoaderMantine } from "@mantine/core";
import styled from "styled-components";

export const Loader = styled(LoaderMantine)`
    stroke: ${({ theme }) => theme.color.primary600};
`;
